// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__JpTwt","loadingWrap":"styles_loadingWrap__qJtxT","noData":"styles_noData__30w87","noDataIcon":"styles_noDataIcon__MtSLP"};